<template>
  <div id="VoipList">
    <SolutionsList
      :list="list"
      :view-loader="viewLoader"
      :view-error="viewError"
      :no-data-message="$t('voip.noData')"
      :colspan="4"
      :page-size="pageSize"
    >
      <template #table-headers>
        <th v-if="!$IsMobile()">{{ $t("voip.assetType") }}</th>
        <th>{{ $t("voip.solution") }}</th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
      </template>
      <template #mobile-row="{ item }">
        <MobileCard
          :titles="['solution_type', 'solution']"
          :item="item"
          translation-path="ticketsList.Voip"
        >
        </MobileCard>
      </template>
      <template #desktop-row="{ item }">
        <tr>
          <td>
            <span>{{
              $t("voip.types." + item.solution_type)
            }}</span>
          </td>
          <td>
            <span>{{ item.solution }}</span>
          </td>
          <td>
            <HelpRequestBtn
              :component-name="'VoipIncidentForm'"
              :asset-type="'voip'"
              :item-id="item.id"
              :icon="'warning'"
              :label="$t('help.incident.formTitle')"
              :skip-duplicate-warning="true"
            />
          </td>
          <td>
            <HelpRequestBtn
              :asset-type="'voip'"
              :component-name="'VoipChangeRequestForm'"
              :item-id="item.id"
              :icon="'person'"
              :label="$t('help.changeRequest.formTitle')"
              :skip-duplicate-warning="true"
            />
          </td>
        </tr>
      </template>
    </SolutionsList>
  </div>
</template>

<script>
import SolutionsList from "@/components/Solutions/SolutionsList.vue";
import HelpRequestBtn from "@/components/Tables/HelpRequestBtn";
import MobileCard from "@/components/Cards/MobileCard.vue";

export default {
  name: "VoipList",
  components: {
    MobileCard,
    SolutionsList,
    HelpRequestBtn,
  },
  props: {
    list: Array,
    viewLoader: Boolean,
    viewError: Boolean,
    noItems: Boolean,
    pageSize: {
      type: Number,
      default: 10,
    },
  },
};
</script>
